import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';
import { PtInput, PtSelect, PtRadio } from '../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import DropdownLib from '../../../DropdownLib';

export default class Structure extends Component {

    constructor(props) {
        super(props);
        const { minorModel } = this.props;
        this.state = minorModel.structure;
        console.log(this.state)
    }

    render() {
        const { typeOptions,
                materialOptions,
                numCellsOptions } = DropdownLib.getDropdowns().MS_Structure;
        const { ownerOptions } = DropdownLib.getDropdowns().CS_XSection;
        const yesNoOptions = [
            { key: 0, label: 'N/A', value: 0 },
            { key: 1, label: 'Yes', value: 1 },
            { key: 2, label: 'No', value: 2 }
        ]
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>

                    <PtSelect label="Type" options={typeOptions} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                        defaultVal={this.state.structType} name="structType" />
                    <PtSelect label="Material" options={materialOptions} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                        defaultVal={this.state.material} name="material" />
                    <PtInput inputType="distanceft" placeholder="0" label="Span Length (ft)" onChange={this.onInputChange} disabled={this.props.disabled}
                        value={this.state.spanLength} name="spanLength" />

                    <PtInput inputType="distanceft" placeholder="0" label="Cell Diameter (ft)" onChange={this.onInputChange} disabled={this.props.disabled}
                        value={this.state.cellDiameter} name="cellDiameter" />
                    <PtInput inputType="distanceft" placeholder="0" label="Cell Width (ft)" onChange={this.onInputChange} disabled={this.props.disabled}
                        value={this.state.cellWidth} name="cellWidth" />
                    <PtInput inputType="distanceft" placeholder="0" label="Cell Height (ft)" onChange={this.onInputChange} disabled={this.props.disabled}
                        value={this.state.cellHeight} name="cellHeight" />
                    <PtInput inputType="distanceft" placeholder="0" label="Cell Length (ft)" onChange={this.onInputChange} disabled={this.props.disabled}
                        value={this.state.cellLength} name="cellLength" />

                    <PtSelect label="Number of Cells" options={numCellsOptions} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                        defaultVal={this.state.numberOfCells} name="numberOfCells" />
                    <PtInput inputType="year" placeholder="1990" label="Year Installed" onChange={this.onInputChange} disabled={this.props.disabled}
                        value={this.state.yearInstalled} name="yearInstalled" />
                    <PtInput inputType="number" placeholder="0" label="Depth of Cover (ft)" onChange={this.onInputChange} disabled={this.props.disabled}
                        value={this.state.depthOfCover} name="depthOfCover" />

                    <PtRadio label="Aprons" options={yesNoOptions} value={this.state.aprons} disabled={this.props.disabled}
                        name="aprons" onChange={this.onChangeRadio}/>
                    <PtRadio label="Bevel" options={yesNoOptions} value={this.state.bevel} disabled={this.props.disabled}
                        name="bevel" onChange={this.onChangeRadio} />

                    <PtInput inputType="money" placeholder="0" label="Replacement Cost" value={this.state.replacementCost} disabled={this.props.disabled}
                        name="replacementCost" onChange={this.onInputChange} />
                    <PtSelect label="Owner" options={ownerOptions} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                        defaultVal={this.state.owner} name="owner" />
                </ScrollArea>
            </Container>
        );
    }

    // TODO: PtRadio todo..

    onChangeDropdown = (e) => {
        const { target } = e;
        const {name, value} = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
    }

    onInputChange = (e) => {
        const {name, value} = e.target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: value === '' ? 0 : parseFloat(value) });
    }

    onChangeRadio = (e, target) => {
        const {name, value} = target;
        this.props.triggerNeedSave();
        this.setState({ [name]: value });
    }

    componentDidUpdate() {
        this.props.minorModel.structure = this.state;
    }
}


// WEBPACK FOOTER //
// ./src/layers/tabs/minor-structs/structure.js